import { OneTimePersonDto } from '@api/models/invitation/OneTimePersonDto';

export interface VisitorLike {
  name?: string | null;
  lastName?: string | null;
  email?: string | null;
  phone?: string | null;
  language?: string | null;
  /** Stable client-side id used as React key; not sent to backend. */
  _uid?: string;
}

export const toOneTimePersonDto = (visitor: VisitorLike): OneTimePersonDto => ({
  name: visitor.name ?? '',
  lastName: visitor.lastName ?? '',
  email: visitor.email || undefined,
  phone: visitor.phone || undefined,
  language: visitor.language ?? '',
});
